import type {
  PurchaseOrder,
  PurchaseOrderItem,
  POSourceType,
  POStatus,
  DiscrepancyAction,
} from '@/domain/entities/purchase-order.entity'
import type { PurchaseOrderDto, PurchaseOrderItemDto } from './purchase-order.dto'

export const purchaseOrderMapper = {
  toItem(dto: PurchaseOrderItemDto): PurchaseOrderItem {
    return {
      id: dto.id,
      ingredientId: dto.ingredient_id,
      ingredientName: dto.ingredient_name,
      unitId: dto.unit_id,
      unitName: dto.unit_name,
      qtyOrdered: Number(dto.qty_ordered) || 0,
      qtyOrderedBase: Number(dto.qty_ordered_base) || 0,
      qtyReceived: Number(dto.qty_received) || 0,
      qtyReceivedBase: Number(dto.qty_received_base) || 0,
      originalUnitPrice: dto.original_unit_price ?? dto.unit_price,
      unitPrice: dto.unit_price,
      total: dto.total,
      sourceCOGS: dto.source_cogs,
      discrepancyAction: dto.discrepancy_action as DiscrepancyAction | undefined,
      differenceReason: dto.difference_reason,
    }
  },

  toEntity(dto: PurchaseOrderDto): PurchaseOrder {
    return {
      id: dto.id,
      poNumber: dto.po_number,
      outletId: dto.outlet_id,
      outletName: dto.outlet_name,
      sourceType: (dto.source_type as POSourceType) || 'supplier',
      sourceOutletId: dto.source_outlet_id ?? undefined,
      sourceOutletName: dto.source_outlet_name,
      supplierName: dto.supplier_name ?? undefined,
      invoiceNo: dto.invoice_no ?? undefined,
      note: dto.note,
      status: (dto.status as POStatus) || 'pending',
      priceRevisionNote: dto.price_revision_note,
      discrepancyReviewNote: dto.discrepancy_review_note,
      total: dto.total,
      sourceCOGS: dto.source_cogs,
      orderDate: dto.order_date,
      dispatchedAt: dto.dispatched_at ?? undefined,
      dispatchedBy: dto.dispatched_by ?? undefined,
      receivedAt: dto.received_at ?? undefined,
      receivedBy: dto.received_by ?? undefined,
      cancelledAt: dto.cancelled_at ?? undefined,
      cancelledBy: dto.cancelled_by ?? undefined,
      cancelReason: dto.cancel_reason,
      createdBy: dto.created_by,
      createdAt: dto.created_at,
      updatedAt: dto.updated_at,
      items: (dto.items ?? []).map(purchaseOrderMapper.toItem),
    }
  },
}
